import { api } from '../../app/api';

import type { ImpersonationStatus } from './impersonation.schema';
import { ImpersonationStatusResponseSchema } from './impersonation.schema';

const impersonationApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getImpersonationStatus: builder.query<ImpersonationStatus, void>({
            query: () => ({
                url: '/v2/account/impersonation',
                method: 'GET',
            }),
            transformResponse: (raw: unknown) =>
                ImpersonationStatusResponseSchema.parse(raw).data,
            providesTags: [{ type: 'Impersonation', id: 'CURRENT' }],
        }),

        startImpersonation: builder.mutation<ImpersonationStatus, number>({
            query: (userId) => ({
                url: '/v2/account/impersonate/[userId]',
                method: 'POST',
                query: { userId },
                body: {},
            }),
            transformResponse: (raw: unknown) =>
                ImpersonationStatusResponseSchema.parse(raw).data,
            invalidatesTags: [{ type: 'Impersonation', id: 'CURRENT' }],
        }),

        stopImpersonation: builder.mutation<ImpersonationStatus, void>({
            query: () => ({
                url: '/v2/account/impersonate/stop',
                method: 'POST',
                body: {},
            }),
            transformResponse: (raw: unknown) =>
                ImpersonationStatusResponseSchema.parse(raw).data,
            invalidatesTags: [{ type: 'Impersonation', id: 'CURRENT' }],
        }),
    }),
});

export const {
    useGetImpersonationStatusQuery,
    useStartImpersonationMutation,
    useStopImpersonationMutation,
} = impersonationApi;
